module.exports = __webpack_public_path__ + "static/img/news-20210129.55608ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20210129.png
// module id = RdnO
// module chunks = 0